<template>
  <div class="ro">
    <!-- تب های فرم تنظیمات -->
    <div class="row">
      <div class="col p-0">
        <!-- تب های سربرگ فرم تنظیمات -->
        <ul class="nav nav-tabs">
          <!-- تب تنظیمات فرم ورود کاربران -->
          <li class="nav-item activeNav rounded-top">
            <a
              href="#tabDoc"
              id="home-tab"
              class="nav-link active d-flex justify-content-between align-items-center"
              data-toggle="tab"
            >
              تنظیمات فرم ورود کاربران
            </a>
          </li>
          <!-- تب تنظیمات میزکار کاربر -->
          <li class="nav-item rounded-top">
            <a
              href="#tabInfo"
              id="profile-tab"
              class="nav-link d-flex justify-content-between align-items-center"
              data-toggle="tab"
            >
              تنظیمات میزکار کاربر
            </a>
          </li>
          <!-- تب تنظیمات سطح امنیتی رمز ورود -->
          <li class="nav-item rounded-top">
            <a
              href="#tabPassword"
              id="password-tab"
              class="nav-link d-flex justify-content-between align-items-center"
              data-toggle="tab"
            >
              تنظیمات سطح امنیتی رمز ورود
            </a>
          </li>
          <!-- تنظیمات ارسال پیامک -->
          <li class="nav-item rounded-top">
            <a
              href="#tabSMSPanel"
              id="smspanel-tab"
              class="nav-link d-flex justify-content-between align-items-center"
              data-toggle="tab"
            >
              تنظیمات ارسال پیامک
            </a>
          </li>
          <!-- تب تنظیمات حجم مجاز جدول نشان ها -->
          <li class="nav-item rounded-top">
            <a
              href="#tabAllowedCount"
              id="allowedCount-tab"
              class="nav-link d-flex justify-content-between align-items-center"
              data-toggle="tab"
            >
              تنظیم حجم مجاز ثبت نشان ها
            </a>
          </li>
        </ul>

        <!-- بدنه فرم تنظیمات -->
        <div class="tab-content rounded shadow z-depth-1 p-1">

          <!-- بدنه تنظیمات فرم ورود کاربران -->
          <div class="tab-pane fade show active w-100" id="tabDoc">
            <!-- جدول محتویات -->
            <div class="row text-right p-5" style="font-size: 14px;">
              <!-- تعداد تلاش ناموفق -->
              <div class="col-12">
                <div class="row w-100 d-flex justify-content-start align-items-center">
                  <div class="col-4 p-0">
                    تعداد مجاز درج اشتباه رمز ورود و کد امنیتی (بار)
                  </div>
                  <div class="col-2">
                    <input 
                      type="text" 
                      v-model="settingWebAppLocal.TryLoginCount" 
                      class="form-control form-control-sm text-center mr-2" 
                      style="direction: ltr;"
                      v-on:keypress="onlyNumberAccept"
                    >
                  </div>
                </div>
              </div>
              <!-- مدت مسدود شدن دسترسی -->
              <div class="col-12 mt-1">
                <div class="row w-100 d-flex justify-content-start align-items-center">
                  <div class="col-4 p-0">
                    مدت زمان مسدود شدن دسترسی کاربر (دقیقه)
                  </div>
                  <div class="col-2">
                    <input 
                      type="text" 
                      v-model="settingWebAppLocal.BlockIPTime" 
                      class="form-control form-control-sm text-center mr-2" 
                      style="direction: ltr;"
                      v-on:keypress="onlyNumberAccept"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- بدنه تنظیمات میزکار کاربر -->
          <div class="tab-pane fade w-100" id="tabInfo">
            <div class="row text-right p-5" style="font-size: 14px;">
              <!-- مدت میزکار -->
              <div class="col-12">
                <div class="row w-100 d-flex justify-content-start align-items-center">
                  <div class="col-4 p-0">
                    مدت زمان مجاز عدم فعالیت در میزکار کاربر (دقیقه)
                  </div>
                  <div class="col-2">
                    <input 
                      type="text" 
                      class="form-control form-control-sm text-center mr-2" 
                      style="direction: ltr;"
                      v-model="settingWebAppLocal.LogOutDashboardTime" 
                      v-on:keypress="onlyNumberAccept"
                    >
                  </div>
                </div>
              </div>
              <!-- مدت نمایش پیام هشدار خروج -->
              <div class="col-12 mt-1">
                <div class="row w-100 d-flex justify-content-start align-items-center"">
                  <div class="col-4 p-0">
                    مدت زمان نمایش هشدار خروج از میزکار (ثانیه)
                  </div>
                  <div class="col-2">
                    <input 
                      type="text" 
                      class="form-control form-control-sm text-center mr-2" 
                      style="direction: ltr;"
                      v-model="settingWebAppLocal.TimeShowLogOutDialogue" 
                      v-on:keypress="onlyNumberAccept"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- بدنه تنظیمات سطوح امنیتی رمز ورود -->
          <div class="tab-pane fade w-100" id="tabPassword">
            <div class="row pt-3">
              <div class="col">
                <div class="h6 p-1 text-right form-check d-flex align-items-center">
                  <input class="form-check-input" type="radio" value="3" v-model="settingWebAppLocal.PasswordSecurityLevel" name="flexRadioDefault" id="radioMedium"/>
                  <label class="form-check-label mr-4 pt-1" for="radioMedium">سطح 3 (امنیت متوسط)</label>
                </div>
                <div class="h7" style='text-align: right; width: 100%; font-weight: 100;'>
                  <ul>
                    <li>حداقل طول رمز ورود 8 نویسه باشد</li>
                    <li>ترکیب رمز ورود ساده نباشد (123456789)</li>
                    <li>رمز ورود حاوی عدد باشد</li>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="h6 p-1 text-right form-check d-flex align-items-center">
                  <input class="form-check-input" type="radio" value="4" v-model="settingWebAppLocal.PasswordSecurityLevel" name="flexRadioDefault" id="radioStrong"/>
                  <label class="form-check-label mr-4 pt-1" for="radioStrong">سطح 4 (امنیت قوی)</label>
                </div>
                <div class="h7" style='text-align: right; width: 100%; font-weight: 100;'>
                  <ul>
                    <li>حداقل طول رمز ورود 8 نویسه باشد</li>
                    <li>ترکیب رمز ورود ساده نباشد (123456789)</li>
                    <li>رمز ورود حاوی عدد باشد</li>
                    <li>رمز ورود حاوی حروف بزرگ و کوچک انگلیسی باشد</li>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="h6 p-1 text-right form-check d-flex align-items-center">
                  <input class="form-check-input" type="radio" value="5" v-model="settingWebAppLocal.PasswordSecurityLevel" name="flexRadioDefault" id="radioVeryStrong"/>
                  <label class="form-check-label mr-4 pt-1" for="radioVeryStrong">سطح 5 (امنیت خیلی قوی)</label>
                </div>
                <div class="h7" style='text-align: right; width: 100%; font-weight: 100;'>
                  <ul>
                    <li>حداقل طول رمز ورود 8 نویسه باشد</li>
                    <li>ترکیب رمز ورود ساده نباشد (123456789)</li>
                    <li>رمز ورود حاوی عدد باشد</li>
                    <li>رمز ورود حاوی حروف بزرگ و کوچک انگلیسی باشد</li>
                    <li>رمز ورود حاوی نویسه های خاص ($#@!%&* ...) باشد</li>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="h6 p-1 text-right form-check d-flex align-items-center">
                  <input class="form-check-input" type="radio" value="6" v-model="settingWebAppLocal.PasswordSecurityLevel" name="flexRadioDefault" id="radioVeryGood"/>
                  <label class="form-check-label mr-4 pt-1" for="radioVeryGood">سطح 6 (امنیت بسیار خوب)</label>
                </div>
                <div class="h7" style='text-align: right; width: 100%; font-weight: 100;'>
                  <ul>
                    <li>حداقل طول رمز ورود 12 نویسه باشد</li>
                    <li>ترکیب رمز ورود ساده نباشد (123456789)</li>
                    <li>رمز ورود حاوی عدد باشد</li>
                    <li>رمز ورود حاوی حروف بزرگ و کوچک انگلیسی باشد</li>
                    <li>رمز ورود حاوی نویسه های خاص ($#@!%&* ...) باشد</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- بدنه تنظیمات ارسال پیامک -->
          <div class="tab-pane fade show w-100" id="tabSMSPanel">
            <!-- جدول محتویات -->
            <div class="row text-right p-5" style="font-size: 14px;">
              <!-- تعداد تلاش ناموفق -->
              <div class="col-12">
                <div class="row w-100 d-flex justify-content-start align-items-center">
                  <div class="col-3 p-0">
                    API Key اتصال به پنل پیامک کاوه نگار
                  </div>
                  <div class="col-9">
                    <input 
                      type="text" 
                      v-model="settingWebAppLocal.SMSKavenegarKey" 
                      class="form-control form-control-sm text-center mr-2" 
                      style="direction: ltr;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- بدنه تنظیمات حجم مجاز جدول نشان ها -->
          <div class="tab-pane fade w-100" id="tabAllowedCount">
            <div class="row text-right p-5" style="font-size: 14px;">
              <!-- حجم مجاز -->
              <div class="col-12">
                <div class="row w-100 d-flex justify-content-start align-items-center">
                  <div class="col-4 p-0">
                    تعداد رکورد مجاز جهت نگهداری در جدول نشان ها (Logs)
                  </div>
                  <div class="col-2">
                    <input 
                      type="text" 
                      class="form-control form-control-sm text-center mr-2" 
                      style="direction: ltr;"
                      v-model="settingWebAppLocal.CountAllowedLog" 
                      v-on:keypress="onlyNumberAccept"
                    >
                  </div>
                </div>
              </div>
              <!-- مسیر ذخیره سازی -->
              <div class="col-12 mt-1">
                <div class="row w-100 d-flex justify-content-start align-items-center">
                  <div class="col-4 p-0">
                    مسیر ذخیره سازی سرریز جدول نشان ها
                  </div>
                  <div class="col-2">
                    <input 
                      type="text" 
                      class="form-control form-control-sm text-left mr-2" 
                      style="direction: ltr;"
                      v-model="settingWebAppLocal.PathSaveLogFile" 
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- میله ابزار پایین سند -->
    <div class="row d-flex justify-content-end mt-3">
      <!-- دکمه های پایین فرم -->
      <div class="col-6 p-0">
        <div
          style="background-color: #78909c"
          class="
            bg-secondary
            d-inline-flex
            justify-content-end
            align-items-center
            rounded
          "
        >
          <a
            v-on:click="SaveSettingToServer()"
            class="text-decoration-none px-4 text-white m-0"
          >
            <strong>ذخیره تنظیمات در سرور</strong>
          </a>
          <a
            v-on:click="SaveSettingToServer()"
            style="background-color: #623879"
            class="text-decoration-none p-3 text-white m-0 rounded-left"
          >
            <i class="fas fa-save fa-2x"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      settingWebAppLocal: {
        // شناسه سمت سرور
        ID: 1,
        // مدت زمان مسدود شدن حساب کاربری - به دقیقه
        BlockIPTime: 5,
        // مدت زمان عدم فعالیت کاربر در میزکار - به دقیقه
        LogOutDashboardTime: 15,
        // تعداد مجاز تلاش ناموفق جهت ورود
        TryLoginCount: 3,
        // مدت زمان نمایش پیام پایان مهلت استفاده از میزکار - به ثانیه
        TimeShowLogOutDialogue: 30,
        // سطح امنیتی رمز عبور
        PasswordSecurityLevel: 3,
        // حجم مجاز جدول نشان ها
        CountAllowedLog: 1000,
        // مسیر ذخیره سازی سرریز جدول نشان ها
        PathSaveLogFile: 'E:\\',
      },
    };
  },
  created() {
    this.getSettingWebApp();
  },
  methods: {
    // درج فقط عدد مجاز است
    onlyNumberAccept($event) {
      if (!/\d/.test($event.key)) {
        return $event.preventDefault();
      }
    },
    // دریافت تنظیمات نرم افزار از مخزن اصلی
    async getSettingWebApp() {
      let tempSetting = await this.$store.getters.getSettingWebApp;
      // مقداردهی به مخزن محلی
      this.settingWebAppLocal = {
        ID: tempSetting.ID,
        BlockIPTime: tempSetting.BlockIPTime,
        LogOutDashboardTime: tempSetting.LogOutDashboardTime,
        TryLoginCount: tempSetting.TryLoginCount,
        TimeShowLogOutDialogue: tempSetting.TimeShowLogOutDialogue,
        PasswordSecurityLevel: tempSetting.PasswordSecurityLevel,
        SMSKavenegarKey: tempSetting.SMSKavenegarKey,
        CountAllowedLog: tempSetting.CountAllowedLog,
        PathSaveLogFile: tempSetting.PathSaveLogFile
      };
    },
    // ذخیره تنظیمات در سرور
    async SaveSettingToServer() {
      let tempData = this.settingWebAppLocal;

      if (
        tempData.BlockIPTime == "" ||
        tempData.LogOutDashboardTime == "" ||
        tempData.TryLoginCount == "" ||
        tempData.TimeShowLogOutDialogue == ""
      ) {
        // ثبت کد حساب الزامی است
        this.$store.dispatch("notify", {
          notText: "ثبت تمام مقادیر تنظیمات الزامی است !",
          timeOut: 2500,
        });
      } else {
        // دریافت توکن احراز هویت
        let token = await this.$store.getters.getUserData.token;

        // ثبت تنظیمات در سرور
        await this.$store.dispatch("EditTbSettingWebAppToServer", {
          SettingWebApp: this.settingWebAppLocal,
          token: token,
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/SettingApp/SettingApp.vue